import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import {
  Organization,
  OrganizationChatScope,
  OrganizationChatSettings,
} from "../../interfaces/organization";
import { Observable } from "rxjs";
import { Guid } from "../../types/guid";

@Injectable({
  providedIn: "root",
})
export class OrganizationsService {
  constructor(private apiService: ApiService) {}

  getOrganizations(): Observable<Organization[]> {
    return this.apiService.getRequest<Organization[]>(
      "orgadmin/organizations/",
    );
  }

  setRankingInOrganization(
    OrganizationId: Guid,
    in_ranking: boolean,
  ): Observable<boolean> {
    return this.apiService.putRequest<boolean>(
      `orgadmin/organizations/${OrganizationId}/in_ranking/`,
      { in_ranking },
    );
  }

  getChatSettings(OrganizationId: Guid): Observable<OrganizationChatSettings> {
    return this.apiService.getRequest<OrganizationChatSettings>(
      `orgadmin/organizations/${OrganizationId}/chat-settings/`,
    );
  }

  updateChatSettings(
    OrganizationId: Guid,
    chat_scope: OrganizationChatScope,
    chat_enabled: boolean,
  ): Observable<OrganizationChatSettings> {
    return this.apiService.patchRequest<OrganizationChatSettings>(
      `orgadmin/organizations/${OrganizationId}/chat-settings/`,
      { chat_scope, chat_enabled },
    );
  }
}
